import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import FormComponent from '../../../Reusable_Components/FormComponent';

const OpportunityDocumentInput = () => {
  const [formData, setFormData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const { documentId: rawDocumentId = '' } = useParams();
  const decodedId = rawDocumentId ? atob(rawDocumentId) : rawDocumentId;
  const documentId = decodedId.replace(/\D/g, '');

  useEffect(() => {
    if (documentId) {
      setIsEditing(true);
      fetchOpportunityDocument();
    }
  }, [documentId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchOpportunityDocument = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.opportunityDocument}${documentId}/`, { headers });
      const doc = response.data?.data ?? response.data;
      setFormData({
        id: doc.id,
        opportunity: doc.opportunity?.id ?? doc.opportunity,
        name: doc.name,
        description: doc.description,
        file: null,
      });
    } catch (error) {
      console.error('Error fetching document details:', error);
    }
  };

  const documentFields = [
    {
      name: 'opportunity', label: 'Opportunity', type: 'async-select',
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (o) => o.opportunity_name,
    },
    { name: 'name', label: 'Document Name', type: 'text' },
    { name: 'description', label: 'Description', type: 'textarea', required: false },
    { name: 'file', label: 'File', type: 'file', required: !isEditing },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Document' : 'Upload Opportunity Document'}</h1>
      <FormComponent fields={documentFields} initialFormData={formData} route="opportunityDocument" />
    </div>
  );
};

export default OpportunityDocumentInput;
